/**
 * Add keyboard commands to debug toggle closed/open states
 */
export default {

    async mounted() {
        this.addDebugCommands();
    },

    beforeDestroy() {
        if (this.$options.keyboardJs) {
            this.$options.keyboardJs.reset();
        }
    },

    methods: {
        /**
         *
         */
        addDebugCommands() {
            this.$options.keyboardJs = require('keyboardjs');
            this.$options.keyboardJs.bind('1', () => {
                this.$store.commit('apidata/setEachLiftStatus', 'OPEN');
                this.showDebugBox('lifts', 'OPEN');
                this.$refs.map.initMapStatus();
            });
            this.$options.keyboardJs.bind('2', () => {
                this.$store.commit('apidata/setEachLiftStatus', 'CLOSED');
                this.showDebugBox('lifts', 'CLOSED');
                this.$refs.map.initMapStatus();
            });
            this.$options.keyboardJs.bind('3', () => {
                this.$store.commit('apidata/setEachLiftStatus', 'RESTRICTED');
                this.showDebugBox('lifts', 'RESTRICTED');
                this.$refs.map.initMapStatus();
            });
            this.$options.keyboardJs.bind('4', () => {
                this.$store.commit('apidata/setEachLiftStatus', 'UNAVAILABLE');
                this.showDebugBox('lifts', 'UNAVAILABLE');
                this.$refs.map.initMapStatus();
            });
            this.$options.keyboardJs.bind('5', () => {
                this.$store.commit('apidata/setEachLiftStatus', 'IN_PREPARATION');
                this.showDebugBox('lifts', 'IN_PREPARATION');
                this.$refs.map.initMapStatus();
            });
            this.$options.keyboardJs.bind('6', () => {
                this.$store.commit('apidata/setEachTrackStatus', 'OPEN');
                this.showDebugBox('tracks', 'OPEN');
                this.$refs.map.initMapStatus();
            });
            this.$options.keyboardJs.bind('7', () => {
                this.$store.commit('apidata/setEachTrackStatus', 'CLOSED');
                this.showDebugBox('tracks', 'CLOSED');
                this.$refs.map.initMapStatus();
            });
            this.$options.keyboardJs.bind('8', () => {
                this.$store.commit('apidata/setEachTrackStatus', 'RESTRICTED');
                this.showDebugBox('tracks', 'RESTRICTED');
                this.$refs.map.initMapStatus();
            });
            this.$options.keyboardJs.bind('9', () => {
                this.$store.commit('apidata/setEachTrackStatus', 'UNAVAILABLE');
                this.showDebugBox('tracks', 'UNAVAILABLE');
                this.$refs.map.initMapStatus();
            });
            this.$options.keyboardJs.bind('0', () => {
                this.$store.commit('apidata/setEachTrackStatus', 'IN_PREPARATION');
                this.showDebugBox('tracks', 'IN_PREPARATION');
                this.$refs.map.initMapStatus();
            });
        },

        showDebugBox(type, state) {
            this.$store.commit('debug/setIsDebugBoxVisible', true);
            if (type === 'lifts') {
                this.$store.commit('debug/setDebugStatusLifts', state);
            } else if (type === 'tracks') {
                this.$store.commit('debug/setDebugStatusTracks', state);
            }

        }
    },
};
